import React from 'react'

import Text from '../../../../components/pdf/Text'
import { Table, TableRow } from '../../../../components/pdf/Table'
import { TableCol } from '../../../../components/pdf/Table'
import View from '../../../../components/pdf/View'
import Grid, { Col } from '../../../../components/pdf/Grid'
import { useReplies } from '../_load/ServiceOrderLoader'
import { findReplyByQuestionId, formatEnglishDate, getReplyValue } from '../_helpers/pdfHelpers'
import Separator from '../../../../components/pdf/Separator'

const BisPageContent = () => {
  const replies = useReplies()

  const form = getReplyValue(findReplyByQuestionId(replies, 222))
  const consignee = getReplyValue(findReplyByQuestionId(replies, 223))
  const address1 = getReplyValue(findReplyByQuestionId(replies, 224))
  const address2 = getReplyValue(findReplyByQuestionId(replies, 225))

  const addressAndNumber = `${address1?.address}, ${address1?.number} - ${address1?.neighborhood}`
  const cityAndState = `${address1?.city}/${address1?.state}`

  const postalCode = getReplyValue(findReplyByQuestionId(replies, 226))
  const phoneFax = getReplyValue(findReplyByQuestionId(replies, 227))

  const disposition = getReplyValue(findReplyByQuestionId(replies, 228)).map(item => item.name)
  const dispositionB1 = getReplyValue(findReplyByQuestionId(replies, 229))
  const dispositionB2 = getReplyValue(findReplyByQuestionId(replies, 230))

  const dispositionC = getReplyValue(findReplyByQuestionId(replies, 231))
  const dispositionD = getReplyValue(findReplyByQuestionId(replies, 232))
  const dispositionE = getReplyValue(findReplyByQuestionId(replies, 233))

  const natureOfBusiness = getReplyValue(findReplyByQuestionId(replies, 235))
  const businessRelationship = getReplyValue(findReplyByQuestionId(replies, 236))
  const businessRelationshipYears = getReplyValue(findReplyByQuestionId(replies, 237))

  const additionalInformation = getReplyValue(findReplyByQuestionId(replies, 238))
  const assistanceInPreparingStatement = getReplyValue(findReplyByQuestionId(replies, 239))

  const nameOfOfficial = getReplyValue(findReplyByQuestionId(replies, 240))
  const titleOfOfficial = getReplyValue(findReplyByQuestionId(replies, 241))
  const dateOfOfficial = getReplyValue(findReplyByQuestionId(replies, 242))

  const nameOfPurchaser = getReplyValue(findReplyByQuestionId(replies, 243))
  const signatureOfPurchaser = getReplyValue(findReplyByQuestionId(replies, 244))
  const nameOfOfficial2 = getReplyValue(findReplyByQuestionId(replies, 245))
  const titleOfOfficial2 = getReplyValue(findReplyByQuestionId(replies, 246))
  const dateOfOfficial2 = getReplyValue(findReplyByQuestionId(replies, 247))
  const signatureOfOfficial2 = getReplyValue(findReplyByQuestionId(replies, 248))
  const titleOfSigner = getReplyValue(findReplyByQuestionId(replies, 249))
  const dateOfSigner = getReplyValue(findReplyByQuestionId(replies, 250))
  const nameOfExporter = getReplyValue(findReplyByQuestionId(replies, 251))
  const nameOfSigner = getReplyValue(findReplyByQuestionId(replies, 252))

  return (
    <View pageBreakAfter>
      <Table useFontBaseColor fixedLayout width="100%">
        <TableRow useFontBaseColor style={{ borderBottom: 'none' }}>
          <TableCol useFontBaseColor colspan="4" width="30%" style={{ borderBottom: '1px solid rgb(51, 51, 51)' }}>
            <Text>
              FORM <strong>{form}</strong>
            </Text>
            <Text>FORM APPROVED UNDER OMB</Text>
            <Text>CONTROL NO. 0694-0021 </Text>
          </TableCol>
          <TableCol useFontBaseColor colspan="4" width="40%">
            <Text align="center">U.S. DEPARTMENT OF COMMERCE</Text>
            <Text align="center">BUREAU OF INDUSTRY AND SECURITY</Text>
            <Text align="center" size="xxsmall">
              Information furnished herewith is subject to the provisions of the Sections 4812(b)(7) and 4814(b)(1)(B)
              of the Export Control Reform Act (ECRA) and its unauthorized disclosure is prohibited by law.
            </Text>
          </TableCol>
          <TableCol useFontBaseColor colspan="4" width="30%" style={{ borderBottom: '1px solid rgb(51, 51, 51)' }}>
            <Text align="center"> DATE RECEIVED</Text>
            <Text align="center">(Leave Blank)</Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="12">
            <Text align="center" bold size="h5">
              STATEMENT BY ULTIMATE CONSIGNEE AND PURCHASER
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="6" width="50%">
            <Grid gutter={2.5}>
              <Col gutter={2.5}>
                <Text>
                  1. ULTIMATE <br /> CONSIGNEE
                </Text>
              </Col>
              <Col gutter={2.5} flex={1}>
                <Text semibold>{consignee}</Text>
              </Col>
            </Grid>
          </TableCol>
          <TableCol useFontBaseColor colspan="6">
            <Grid gutter={2.5}>
              <Col gutter={2.5}>
                <Text>
                  CITY <br /> &nbsp;
                </Text>
              </Col>
              <Col gutter={2.5} flex={1}>
                <Text semibold>{cityAndState}</Text>
              </Col>
            </Grid>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="6">
            <Grid gutter={2.5}>
              <Col gutter={2.5}>
                <Text>
                  ADDRESS <br /> LINE 1
                </Text>
              </Col>
              <Col gutter={2.5} flex={1}>
                <Text semibold>{addressAndNumber}</Text>
              </Col>
            </Grid>
          </TableCol>
          <TableCol useFontBaseColor colspan="6">
            <Grid gutter={2.5}>
              <Col gutter={2.5}>
                <Text>
                  COUNTRY <br /> &nbsp;
                </Text>
              </Col>
              <Col gutter={2.5}>
                <Text semibold>{address1?.country}</Text>
              </Col>
            </Grid>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="6" width="50%">
            <Grid gutter={2.5}>
              <Col gutter={2.5}>
                <Text>
                  ADDRESS <br /> LINE 2
                </Text>
              </Col>
              <Col gutter={2.5} flex={1}>
                <Text semibold>{address2?.search}</Text>
              </Col>
            </Grid>
          </TableCol>
          <TableCol useFontBaseColor colspan="2" width="25%">
            <Grid gutter={2.5}>
              <Col gutter={2.5}>
                <Text>
                  POSTAL <br />
                  CODE
                </Text>
              </Col>
              <Col gutter={2.5} flex={1}>
                <Text semibold>{postalCode}</Text>
              </Col>
            </Grid>
          </TableCol>
          <TableCol useFontBaseColor colspan="4" width="25%">
            <Grid gutter={2.5}>
              <Col gutter={2.5}>
                <Text>TELEPHONE OR FAX</Text>
                <Text semibold>{phoneFax}</Text>
              </Col>
            </Grid>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="12">
            <Text>2. DISPOSITION OR USE OF ITEMS BY ULTIMATE CONSIGNEE NAMED IN BLOCK 1</Text>
            <Text>We certify that the items: (left mouse click in the appropriate box below)</Text>
            <Separator weight={1} />
            <Grid gutter={2.5}>
              <Col gutter={2.5}>
                <Text>A.</Text>
              </Col>
              <Col gutter={2.5}>
                <Text size="h3">{disposition.includes('A') ? '☑' : '☐'}</Text>
              </Col>
              <Col gutter={2.5}>
                <Text>
                  Will be used by us (as capital equipment) in the form in which received in a manufacturing process in
                  the country named in Block 1 and will not be reexported or incorporated into an end product.
                </Text>
              </Col>
            </Grid>
            <Grid gutter={2.5}>
              <Col gutter={2.5}>
                <Text>B.</Text>
              </Col>
              <Col gutter={2.5}>
                <Text size="h3">{disposition.includes('B') ? '☑' : '☐'}</Text>
              </Col>
              <Col gutter={2.5} flex={1}>
                <Grid>
                  <Col>
                    <Text>Will be processed or incorporated by us into the following product (s)</Text>
                  </Col>
                  <Col flex={1}>
                    <Text semibold style={{ paddingLeft: 10, borderBottom: '1px solid rgb(51, 51, 51)' }}>
                      &nbsp;{dispositionB1}
                    </Text>
                  </Col>
                </Grid>
                <Grid>
                  <Col>
                    <Text>to be manufactured in the country named in Block 1 for distribution in</Text>
                  </Col>
                  <Col flex={1}>
                    <Text semibold style={{ paddingLeft: 10, borderBottom: '1px solid rgb(51, 51, 51)' }}>
                      &nbsp;{dispositionB2}
                    </Text>
                  </Col>
                </Grid>
              </Col>
            </Grid>
            <Grid gutter={2.5}>
              <Col gutter={2.5}>
                <Text>C.</Text>
              </Col>
              <Col gutter={2.5}>
                <Text size="h3">{disposition.includes('C') ? '☑' : '☐'}</Text>
              </Col>
              <Col gutter={2.5} flex={1}>
                <Text>
                  Will be resold by us in the form in which received in the country named in Block 1 for use or
                  consumption therein.
                </Text>
                <Grid style={{ lineHeight: 1.5 }}>
                  <Col>
                    <Text>The specific end-use by my customer will be</Text>
                  </Col>
                  <Col flex={1}>
                    <Text semibold style={{ paddingLeft: 10, borderBottom: '1px solid rgb(51, 51, 51)' }}>
                      &nbsp;{dispositionC}
                    </Text>
                  </Col>
                </Grid>
              </Col>
            </Grid>
            <Grid gutter={2.5}>
              <Col gutter={2.5}>
                <Text>D.</Text>
              </Col>
              <Col gutter={2.5}>
                <Text size="h3">{disposition.includes('D') ? '☑' : '☐'}</Text>
              </Col>
              <Col gutter={2.5} flex={1}>
                <Grid>
                  <Col>
                    <Text>Will be reexported by us in the form in which received to</Text>
                  </Col>
                  <Col flex={1}>
                    <Text semibold style={{ paddingLeft: 10, borderBottom: '1px solid rgb(51, 51, 51)' }}>
                      &nbsp;{dispositionD}
                    </Text>
                  </Col>
                </Grid>
              </Col>
            </Grid>
            <Grid gutter={2.5}>
              <Col gutter={2.5}>
                <Text>E.</Text>
              </Col>
              <Col gutter={2.5}>
                <Text size="h3">{disposition.includes('E') ? '☑' : '☐'}</Text>
              </Col>
              <Col gutter={2.5} flex={1}>
                <Grid>
                  <Col>
                    <Text>Other (describe fully)</Text>
                  </Col>
                  <Col flex={1}>
                    <Text semibold style={{ paddingLeft: 10, borderBottom: '1px solid rgb(51, 51, 51)' }}>
                      &nbsp;{dispositionE}
                    </Text>
                  </Col>
                </Grid>
              </Col>
            </Grid>
            <Text>
              NOTE: If BOX (D) is checked, acceptance of this form by the Bureau of Industry and Security as a
              supporting document for license applications shall not be construed as an authorization to reexport the
              items to which the form applies unless specific approval has been obtained from the Bureau of Industry and
              Security for such export.
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="12">
            <Text>3. NATURE OF BUSINESS OF ULTIMATE CONSIGNEE NAMED IN BLOCK 1</Text>
            <Separator weight={1} />
            <Grid gutter={2.5}>
              <Col gutter={2.5} flex={1}>
                <Grid>
                  <Col>
                    <Text>A. The nature of our usual business is</Text>
                  </Col>
                  <Col flex={1} style={{ paddingLeft: 10, borderBottom: '1px solid rgb(51, 51, 51)' }}>
                    <Text semibold>&nbsp;{natureOfBusiness}</Text>
                  </Col>
                </Grid>
              </Col>
            </Grid>
            <Grid gutter={2.5}>
              <Col gutter={2.5} flex={1}>
                <Grid>
                  <Col>
                    <Text> B. Our business relationship with the U.S. exporter is</Text>
                  </Col>
                  <Col flex={1} style={{ paddingLeft: 10, borderBottom: '1px solid rgb(51, 51, 51)' }}>
                    <Text semibold>&nbsp;{businessRelationship}</Text>
                  </Col>
                </Grid>
                <Grid>
                  <Col>
                    <Text>and we have had this business relationship for</Text>
                  </Col>
                  <Col>
                    <Text semibold style={{ padding: '0 10px', borderBottom: '1px solid rgb(51, 51, 51)' }}>
                      &nbsp;{businessRelationshipYears}
                    </Text>
                  </Col>
                  <Col>
                    <Text>year(s).</Text>
                  </Col>
                </Grid>
              </Col>
            </Grid>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="12">
            <Grid gutter={2.5}>
              <Col gutter={2.5}>
                <Text>
                  4. ADDITIONAL <br /> INFORMATION
                </Text>
              </Col>
              <Col gutter={2.5}>
                <Text semibold>{additionalInformation}</Text>
              </Col>
            </Grid>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="12">
            <Grid gutter={2.5}>
              <Col gutter={2.5}>
                <Text>
                  5. ASSISTANCE IN <br /> PREPARING STATEMENT
                </Text>
              </Col>
              <Col gutter={2.5}>
                <Text semibold>{assistanceInPreparingStatement}</Text>
              </Col>
            </Grid>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="12">
            <Text>STATEMENT OF ULTIMATE CONSIGNEE AND PURCHASER</Text>
            <Text size="xsmall">
              We certify that all of the facts contained in this statement are true and correct to the best of our
              knowledge and we do not know of any additional facts which are inconsistent with the above statement. We
              shall promptly send a supplemental statement to the U.S. Exporter, disclosing any change of facts or
              intentions set forth in this statement which occurs after the statement has been prepared and forwarded,
              except as specifically authorized by the U.S. Export Administration Regulations (15 CFR parts 730-774), or
              by prior written approval of the Bureau of Industry and Security, we will not reexport, resell, or
              otherwise dispose of any items approved on a license supported by this statement (1) to any country not
              approved for export as brought to our attention by means of a bill of lading, commercial invoice, or any
              other means, or(2) to any person if we know that it will result directly or indirectly, in disposition of
              the items contrary to the representations made in this statement or contrary to Export Administration
              Regulations.
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="6">
            <Text>
              6. SIGNATURE OF OFFICIAL OF ULTIMATE CONSIGNEE <br /> &nbsp;
            </Text>
          </TableCol>
          <TableCol useFontBaseColor colspan="6">
            <Grid gutter={2.5}>
              <Col gutter={2.5}>
                <Text>
                  7. NAME OF <br /> PURCHASER
                </Text>
              </Col>
              <Col gutter={2.5}>
                <Text semibold>{nameOfPurchaser}</Text>
              </Col>
            </Grid>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="6">
            <Grid gutter={2.5}>
              <Col gutter={2.5}>
                <Text>
                  NAME OF <br /> OFFICIAL
                </Text>
              </Col>
              <Col gutter={2.5}>
                <Text semibold>{nameOfOfficial}</Text>
              </Col>
              <Col gutter={2.5}>
                <Text></Text>
              </Col>
            </Grid>
          </TableCol>
          <TableCol useFontBaseColor colspan="6">
            <Grid gutter={2.5}>
              <Col gutter={2.5}>
                <Text>
                  SIGNATURE OF <br /> PURCHASER
                </Text>
              </Col>
              <Col gutter={2.5}>
                <Text semibold>{signatureOfPurchaser}</Text>
              </Col>
            </Grid>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="6">
            <Grid gutter={2.5}>
              <Col gutter={2.5}>
                <Text>
                  TITLE OF <br /> OFFICIAL
                </Text>
              </Col>
              <Col gutter={2.5}>
                <Text semibold>{titleOfOfficial}</Text>
              </Col>
            </Grid>
          </TableCol>
          <TableCol useFontBaseColor colspan="6">
            <Grid gutter={2.5}>
              <Col gutter={2.5}>
                <Text>
                  NAME OF <br /> OFFICIAL
                </Text>
              </Col>
              <Col gutter={2.5}>
                <Text semibold>{nameOfOfficial2}</Text>
              </Col>
            </Grid>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="6">
            <Grid gutter={2.5}>
              <Col gutter={2.5}>
                <Text>
                  DATE (mm/dd/yyyy) <br /> &nbsp;
                </Text>
              </Col>
              <Col gutter={2.5}>
                <Text semibold>{formatEnglishDate(dateOfOfficial)}</Text>
              </Col>
            </Grid>
          </TableCol>
          <TableCol useFontBaseColor colspan="6">
            <Grid gutter={2.5}>
              <Col gutter={2.5}>
                <Text>
                  TITLE OF <br /> OFFICIAL
                </Text>
              </Col>
              <Col gutter={2.5}>
                <Text semibold>{titleOfOfficial2}</Text>
              </Col>
            </Grid>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="6">
            <Grid gutter={2.5}>
              <Col gutter={2.5}>
                <Text>CERTIFICATION FOR USE OF U.S. EXPORTER -</Text>
                <Text size="xsmall">
                  We certify that no corrections, additions, or alterations were made on this form by us after the form
                  was signed by the (ultimate consignee)(purchaser).
                </Text>
              </Col>
            </Grid>
          </TableCol>
          <TableCol useFontBaseColor colspan="6">
            <Grid gutter={2.5}>
              <Col gutter={2.5}>
                <Text>
                  DATE (mm/dd/yyyy) <br /> &nbsp;
                </Text>
              </Col>
              <Col gutter={2.5}>
                <Text semibold>{formatEnglishDate(dateOfOfficial2)}</Text>
              </Col>
            </Grid>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="6">
            <Grid gutter={2.5}>
              <Col gutter={2.5}>
                <Text>
                  8. NAME OF <br /> EXPORTER
                </Text>
              </Col>
              <Col gutter={2.5}>
                <Text semibold>{nameOfExporter}</Text>
              </Col>
            </Grid>
          </TableCol>
          <TableCol useFontBaseColor colspan="6" style={{ verticalAlign: 'top' }}>
            <Grid gutter={2.5} direction="column" align="flex-start">
              <Col gutter={2.5}>
                <Text>SIGNATURE OF PERSON AUTHORIZED TO CERTIFY FOR EXPORTER</Text>
              </Col>
              <Col gutter={2.5}>
                <Text semibold>{signatureOfOfficial2}</Text>
              </Col>
            </Grid>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="6" style={{ verticalAlign: 'top' }}>
            <Grid gutter={2.5}>
              <Col gutter={2.5}>
                <Text>
                  NAME OF PERSON <br /> SIGNING THIS DOCUMENT
                </Text>
              </Col>
              <Col gutter={2.5}>
                <Text semibold>{nameOfSigner}</Text>
              </Col>
            </Grid>
          </TableCol>
          <TableCol useFontBaseColor colspan="4" style={{ verticalAlign: 'top' }}>
            <Text>TITLE OF PERSON SIGNING THIS DOCUMENT</Text>
            <Separator weight={1} />
            <Text semibold>{titleOfSigner}</Text>
          </TableCol>
          <TableCol useFontBaseColor colspan="2">
            <Text>DATE (mm/dd/yyyy)</Text>
            <Text semibold>{formatEnglishDate(dateOfSigner)}</Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="12">
            <Text>
              We acknowledge that the making of any false statements or concealment of any material fact in connection
              with this statement may result in imprisonment or fine, or both and denial, in whole or in part, of
              participation in U.S. exports and reexports.
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="6">
            <Text size="xsmall">
              Public reporting burden for this collection of information is estimated to average 15 minutes per response
              plus one minute for recordkeeping, including the time for reviewing instruments, searching existing data
              sources, gathering and maintaining the data needed, and completing and reviewing the collection of
              information. Send comments regarding this burden estimate or any other aspect of this collection of
              information, including suggestions for reducing this burden, to the U.S. Department of Commerce,
              Washington, DC 20230, and to the Office of Management and Budget Paperwork
            </Text>
          </TableCol>
          <TableCol useFontBaseColor colspan="6" style={{ verticalAlign: 'top' }}>
            <Text size="xsmall">
              Reduction Project (0694-0021), Washington, D.C. 20503. Notwithstanding any other provision of law, no
              person is obligated to respond to nor shall a person be subject to a penalty for failure to comply with a
              collection of information subject to the Paperwork Reduction Act unless that collection of information
              displays a currently valid OMB Control Number.
            </Text>
          </TableCol>
        </TableRow>
      </Table>
    </View>
  )
}

export default BisPageContent
